// extracted by mini-css-extract-plugin
export default {"root":"Text_root__3FMYH","display1":"Text_display1__Ly-Ub","display2":"Text_display2__1plkn","display3":"Text_display3__c6Mo9","display4":"Text_display4__eRqzI"};